import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { useStoreImperative } from '../../../hooks/useStoreImperative'
import { GenericalRecord } from '../../../types/utilities'

import { RemoteTransferStoreContext } from './contexts/StoreContext'
import { RemoteTransferStoreProviderProps } from './interface'
import { createRemoteTransferStore } from './store/createStore'
import { RemoteTransferStoreUpdater } from './StoreUpdater'

export const RemoteTransferStoreProvider = <
  T extends GenericalRecord,
  P extends GenericalRecord
>({
  ref,
  children,
  /* -------------------------------------------------------------------------- */
  /*                             StoreUpdater Props                             */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: PropsWithChildren<RemoteTransferStoreProviderProps<T, P>>) => {
  const searchForm = useCreationForm()
  const store = useCreation(
    () => createRemoteTransferStore({ searchForm }),
    [searchForm]
  )

  useStoreImperative(ref, store)

  return (
    <RemoteTransferStoreContext value={store}>
      {children}
      <RemoteTransferStoreUpdater {...restProps} />
    </RemoteTransferStoreContext>
  )
}
